import { ADD_ERROR, CLEAR_ERROR, CLEAR_ALL_ERRORS } from './index';

export default (state = [], action) => {
  switch (action.type) {
    case ADD_ERROR:
      return [...state, { id: action.id, error: action.error }];

    case CLEAR_ERROR:
      return state.filter(item => item.id !== action.id);

    case CLEAR_ALL_ERRORS:
      return [];

    default:
      return state;
  }
};
